import type {OrderTestsCatalogResponse} from '@/shared/types/api';

/**
 * Resolve a manually selected test to the ELIS panel id its order submits.
 *
 * The server now resolves THE canonical wrapper per assay
 * (`assayTests[].wrapperElisPanelId`, provider-enabled variant first) — use
 * it whenever present. The legacy scan below — first single-test panel
 * containing the test, over an alphabetized catalog — is kept ONLY as a
 * fallback for a catalog response cached from an older API. That scan is the
 * bug that ordered HbA1c as "DTC - Diabetic Risk" and TSH as "SmartTSH":
 * with the compendium's variant zoo in the catalog, Array.find means the
 * alphabetically-first variant wins.
 *
 * Returns null when nothing resolves (test not orderable), matching the old
 * behavior of silently skipping it.
 */
export function resolveManualTestElisPanelId(
    catalog: Pick<OrderTestsCatalogResponse, 'assayTests' | 'panels'>,
    testId: number
): number | null {
    const assayTest = (catalog.assayTests ?? []).find((t) => t.id === testId);
    if (assayTest?.wrapperElisPanelId != null) {
        return assayTest.wrapperElisPanelId;
    }

    const wrapper = catalog.panels.find((p) => p.testCount === 1 && p.tests.some((t) => t.id === testId));
    return wrapper ? wrapper.elisPanelId : null;
}
